import { ACTIONS } from '../Constants';

const initialState = {
    byId: {},
    filteredById: {},
    loading: false
};

const userFeedback = (state = initialState, action) => {
    let newById;
    let reduced;

    switch (action.type) {
        case ACTIONS.GET_MANY_USER_FEEDBACK: {
            const { userfeedback } = action.payload;
            reduced = userfeedback.reduce((prev, userFeedbackItem) => {
                prev[userFeedbackItem._id] = userFeedbackItem;
                return prev;
            }, {});

            newById = {
                ...state.byId,
                ...reduced
            };
            return {
                ...state,
                byId: newById
            };
        }

        default:
            return state;
    }
};

export default userFeedback;
